import { useState, useEffect } from "react";
import { EMPLOYEE_MANAGEMENT_SERVICE } from "src/utils/Api";
import __ from "src/utils/Translations";
import { mockData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/List/list";
import useHasPermission from "src/utils/hooks/security/useHasPermission";
import { employeeEmployeePermissionRead } from "src/utils/RoleBasedSecurity/permissions";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";
import { mappingOptions } from "src/utils/Api/modifyResponse";

export default function useAhrs(
  asOption = false,
  filterField = null,
  filterValue = null,
  idAsIri = false,
  noFetching = false
) {
  const [data, setData] = useState([]);

  const hasPermission = useHasPermission(employeeEmployeePermissionRead);
  const skipAction = !hasPermission || noFetching;

  useEffect(() => {
    const fetchData = async () =>
      sendBatchRequests({
        skipAction,
        filterField,
        filterValue,
        idAsIri,
        asOption,
        IRI_PREFIX,
        requestParams: {
          service: EMPLOYEE_MANAGEMENT_SERVICE,
          path: "/employees",
          method: "GET",
          mockData,
          itemsPerPage: 100,
          additionalParams: {
            ahr: true,
          },
        },
        mappingType: mappingOptions.byFirstNameAndLastName,
        setData,
      });

    fetchData();
  }, [filterField, filterValue, idAsIri, asOption, skipAction, setData]);

  return data;
}

export const IRI_PREFIX = "/api/employee-management/v1/rest/ahr-roles";
